// frontend/src/App.tsx
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import LoginPage from './app/Login/Page';
import PrivateRoute from './app/PrivateRoute';
import { UserProvider } from './context/userContext';
import { ThemeProvider } from './context/themeContext';
import { ApplicationLayout } from './app/ApplicationLayout';
import { Toaster } from 'react-hot-toast';
import { SuperAdminProvider } from './provider/superadminProvider';
import { MainLayout } from './app/Layout/MainLayout';
import AccessDenied from './app/404/AccessDenied/Page';
import SetupSuppliersPage from './app/Setup/Supplier/Page';
import SetupAddSupplierPage from './app/Setup/Supplier/add/Page';
import SetupEditSupplierPage from './app/Setup/Supplier/edit/Page';
import SetupViewSupplierIdPage from './app/Setup/Supplier/[id]/Page';
import SetupLogisticsPage from './app/Setup/Logistic/Page';
import SetupAddLogisticPage from './app/Setup/Logistic/add/Page';
import SetupEditLogisticPage from './app/Setup/Logistic/edit/Page';
import SetupViewLogisticIdPage from './app/Setup/Logistic/[id]/Page';
import SetupCustomersPage from './app/Setup/Customer/Page';
import SetupAddCustomerPage from './app/Setup/Customer/add/Page';
import SetupEditCustomerPage from './app/Setup/Customer/edit/Page';
import SetupViewCustomerIdPage from './app/Setup/Customer/[id]/Page';
import SetupBrandPage from './app/Products/Brands/Page';
import SetupAddBrandPage from './app/Products/Brands/add/Page';
import SetupEditBrandPage from './app/Products/Brands/edit/Page';
import SetupViewBrandIdPage from './app/Products/Brands/[id]/Page';
import WarehouseProductPage from './app/Products/Product/Page';
import AddWarehouseProductPage from './app/Products/Product/add/Page';
import EditWarehouseProductPage from './app/Products/Product/edit/Page';
import ViewWarehouseProductIdPage from './app/Products/Product/[id]/Page';
import StockInPage from './app/Stocks/StockIn/Page';
import AddStockInPage from './app/Stocks/StockIn/add/Page';
import AddStockInItemPage from './app/Stocks/StockIn/StockInItems/add/Page';
import ViewStockInIdPage from './app/Stocks/StockIn/[id]/Page';
import StockOutPage from './app/Stocks/StockOut/Page';
import AddStockOutPage from './app/Stocks/StockOut/add/Page';
import AddStockOutItemPage from './app/Stocks/StockOut/StockOutItems/add/Page';
import StockAdjustPage from './app/Stocks/StockAdjust/Page';
import AddStockAdjustItemPage from './app/Stocks/StockAdjust/StockAdjustItem/add/Page';
import AddStockAdjustPage from './app/Stocks/StockAdjust/add/Page';
import PickupStockOutPage from './app/Tracking/Pickup/Page';
import ViewStockOutIdPage from './app/Stocks/StockOut/[id]/Page';
import ViewStockAdjustIdPage from './app/Stocks/StockAdjust/[id]/Page';
import TrackingDeliveryConfirmationPage from './app/Tracking/Delivery/Confirmation/Page';
import ViewTrackingPickupIdPage from './app/Tracking/Pickup/[id]/Page';
import CompletedStockOutPage from './app/Tracking/Completed/Page';
import TrackingStandalonePage from './app/Tracking/Standalone/Page';
import AddTrackingStandalonePage from './app/Tracking/Standalone/add/Page';
import EditTrackingStandalonePage from './app/Tracking/Standalone/edit/[id]/Page';
import ViewTrackingStandalonePage from './app/Tracking/Standalone/[id]/Page';
import DeliveryManConfirmationPage from './app/Tracking/Standalone/DeliveryMan/Page';
import SubDeliveryManConfirmationPage from './app/Tracking/Standalone/SubDeliveryMan/Page';
import CustomerConfirmationPage from './app/Tracking/Standalone/Customer/Page';
import TrackingStandaloneSuccessPage from './app/Tracking/Standalone/Success/Page';
import SetupWarehousesPage from './app/Setup/Warehouse/Page';
import SetupAddWarehousePage from './app/Setup/Warehouse/add/Page';
import SetupEditWarehousePage from './app/Setup/Warehouse/edit/Page';
import SetupViewWarehouseIdPage from './app/Setup/Warehouse/[id]/Page';
import AddWarehouseProductItemPageId from './app/Products/ProductItems/add [id]/Page';
import EditStockInPage from './app/Stocks/StockIn/edit/Page';
import AddStockInItemPageId from './app/Stocks/StockIn/StockInItems/add [id]/Page';
import EditStockOutPage from './app/Stocks/StockOut/edit/Page';
import AddStockOutItemPageId from './app/Stocks/StockOut/StockOutItems/add [id]/Page';
import EditStockAdjustPage from './app/Stocks/StockAdjust/edit/Page';
import AddStockAdjustItemPageId from './app/Stocks/StockAdjust/StockAdjustItem/add [id]/Page';
import EditMyAccountPage from './app/MyAccount/edit/Page';
import ViewMyAccountPage from './app/MyAccount/[id]/Page';
import UsersPage from './app/Users/Page';
import GHDashboard from './app/Dashboard/Page';
import AboutPage from './app/About/Page';
import ViewUserIdPage from './app/Users/[id]/Page';
import EditUserPage from './app/Users/edit/Page';
import AddUserPage from './app/Users/add/Page';
import NotFoundPage from './app/404/404NotFound/Page';
import TrackingDeliverySuccessPage from './app/Tracking/Delivery/Success/Page';
import ReportStockBalancePage from './app/Report/StockBalance/Page';
import ReportStockMovementPage from './app/Report/StockMovement/Page';
import ReportStockByBatchPage from './app/Report/StockByBatch/Page';
import PageAccess from './app/PageAccess';
import DeveloperAddUserPage from './app/DeveloperPage/Page';
import WarehouseProductCategoryPage from './app/Products/Category/Page';
import AddWarehouseProductCategoryPage from './app/Products/Category/add/Page';
import EditWarehouseProductCategoryPage from './app/Products/Category/edit/Page';
import ViewWarehouseProductCategoryIdPage from './app/Products/Category/[id]/Page';
import WarehouseProductDepartmentPage from './app/Products/Department/Page';
import AddWarehouseProductDepartmentPage from './app/Products/Department/add/Page';
import EditWarehouseProductDepartmentPage from './app/Products/Department/edit/Page';
import ViewWarehouseProductDepartmentIdPage from './app/Products/Department/[id]/Page';
import WarehouseProductGroupPage from './app/Products/Group/Page';
import AddWarehouseProductGroupPage from './app/Products/Group/add/Page';
import EditWarehouseProductGroupPage from './app/Products/Group/edit/Page';
import ViewWarehouseProductGroupIdPage from './app/Products/Group/[id]/Page';
import ReportStockBalanceIdPage from './app/Report/StockBalance/[id]/Page';
import ReportStockMovementIdPage from './app/Report/StockMovement/[id]/Page';
import ReportStockByBatchIdPage from './app/Report/StockByBatch/[id]/Page';
import AppAnnouncementPage from './app/MobileApp/Announcements/Page';
import AppPreCallPlanPage from './app/MobileApp/PreCallPlans/Page';
import AppPreCallPlanCalendarPage from './app/MobileApp/PreCallPlans/CalendarView/Page';
import AppPostCallPlanPage from './app/MobileApp/PostCallPlans/Page';
import AppPostCallPlanCalendarPage from './app/MobileApp/PostCallPlans/CalendarView/Page';
import AppTrackCheckInPage from './app/MobileApp/TrackCheckIn/Page';
import AppTrackLocationPage from './app/MobileApp/TrackLocations/Page';
import AppUserPage from './app/MobileApp/Users/Page';
import AddAppUserPage from './app/MobileApp/Users/add/Page';
import EditAppUserPage from './app/MobileApp/Users/edit/Page';
import ViewAppUserIdPage from './app/MobileApp/Users/[id]/Page';
import AddAppAnnouncementPage from './app/MobileApp/Announcements/add/Page';
import EditAppAnnouncementPage from './app/MobileApp/Announcements/edit/Page';
import ViewAppAnnouncementIdPage from './app/MobileApp/Announcements/[id]/Page';
import AddAppTrackLocationPage from './app/MobileApp/TrackLocations/add/Page';
import EditAppTrackLocationPage from './app/MobileApp/TrackLocations/edit/Page';
import ViewAppTrackLocationIdPage from './app/MobileApp/TrackLocations/[id]/Page';
import AppUpdatesPage from './app/MobileApp/AppUpdates/Page';
import AddAppUpdatePage from './app/MobileApp/AppUpdates/add/Page';
import EditAppUpdatePage from './app/MobileApp/AppUpdates/edit/Page';
import ViewAppUpdateIdPage from './app/MobileApp/AppUpdates/[id]/Page';
import ViewAppPreCallPlanIdPage from './app/MobileApp/PreCallPlans/[id]/Page';
import ViewAppPostCallPlanIdPage from './app/MobileApp/PostCallPlans/[id]/Page';
import ViewAppTrackCheckInIdPage from './app/MobileApp/TrackCheckIn/[id]/Page';
import AppSalesOrdersPage from './app/SalesOrders/Page';
import ViewAppSalesOrderIdPage from './app/SalesOrders/[id]/Page';
import AddWarehouseProductPiceListPage from './app/Products/ProductPrice/add/Page';
import AppUserCurrentLocationPage from './app/MobileApp/UserCurrentLocation/Page';
import AppUserCurrentLocationIdPage from './app/MobileApp/UserCurrentLocation/[id]/Page';
import ViewAppUserCurrentLocationIdPage from './app/MobileApp/UserCurrentLocation/[id]/Page';
import StockBalanceTransferPage from './app/StockBalanceTransfer/Page';
import AddStockBalanceTransferIdPage from './app/StockBalanceTransfer/add [id]/Page';
import NotificationsPage from './app/Notifications/Page';
import NotificationViewPage from './app/Notifications/View/Page';
import AuditLogPage from './app/AuditLog/Page';
import ServerHealthPage from './app/ServerHealth/Page';
import AIReportHelperPage from './app/AIReportHelper/Page';
import CustomerProfilesPage from './app/AIReportHelper/CustomerProfiles/Page';
import AddCustomerProfilePage from './app/AIReportHelper/CustomerProfiles/add/Page';
import EditCustomerProfilePage from './app/AIReportHelper/CustomerProfiles/edit/Page';
import AnalyticsChartPage from './app/AIReportHelper/Analytics/[id]/Page';
import TemplatesPage from './app/AIReportHelper/Templates/Page';
import DatasetsPage from './app/AIReportHelper/Datasets/Page';
import AddDatasetPage from './app/AIReportHelper/Datasets/add/Page';
import EditDatasetPage from './app/AIReportHelper/Datasets/edit/Page';
import ViewDatasetPage from './app/AIReportHelper/Datasets/view/Page';

const App: React.FC = () => {
  return (
    <ThemeProvider>
    <Router>
      <UserProvider>
        <Toaster
          position="bottom-right"
        />

        <Routes>
          <Route path="/" element={<LoginPage />} />
          <Route path="accessdenied" element={<AccessDenied />} />
          <Route path="gp/tracking/delivery/confirmation/:id" element={<TrackingDeliveryConfirmationPage />} />
          <Route path="gp/tracking/delivery/success" element={<TrackingDeliverySuccessPage />} />
          <Route path="gp/tracking/standalone/delivery-man/:token" element={<DeliveryManConfirmationPage />} />
          <Route path="gp/tracking/standalone/sub-delivery-man/:token" element={<SubDeliveryManConfirmationPage />} />
          <Route path="gp/tracking/standalone/customer/:token" element={<CustomerConfirmationPage />} />
          <Route path="gp/tracking/standalone/success" element={<TrackingStandaloneSuccessPage />} />

          <Route element={<PrivateRoute />}>
            {/* <Route element={<ApplicationLayout />}>
              <Route path="dashboard" element={<Dashboard />} />
            </Route> */}

            {/* Superadmin Pages */}
            <Route element={<MainLayout />}>
              <Route path="gp/dashboard" element={<GHDashboard />} />
              <Route path="gp/notifications" element={<NotificationsPage />} />
              <Route path="gp/about" element={<AboutPage />} />
              <Route path="gp/notifications/view/:id" element={<NotificationViewPage />} />

              <Route element={<PageAccess requiredRole='1' />}>
                <Route path="gp/auditlog" element={<AuditLogPage />} />
                <Route path="gp/server-health" element={<ServerHealthPage />} />
                <Route path="gp/ai-report-helper" element={<AIReportHelperPage />} />
                <Route path="gp/ai-report-helper/customer-profiles" element={<CustomerProfilesPage />} />
                <Route path="gp/ai-report-helper/customer-profiles/add" element={<AddCustomerProfilePage />} />
                <Route path="gp/ai-report-helper/customer-profiles/edit/:id" element={<EditCustomerProfilePage />} />
                <Route path="gp/ai-report-helper/analytics/:id" element={<AnalyticsChartPage />} />
                <Route path="gp/ai-report-helper/templates" element={<TemplatesPage />} />
                <Route path="gp/ai-report-helper/datasets" element={<DatasetsPage />} />
                <Route path="gp/ai-report-helper/datasets/add" element={<AddDatasetPage />} />
                <Route path="gp/ai-report-helper/datasets/edit/:id" element={<EditDatasetPage />} />
                <Route path="gp/ai-report-helper/datasets/view/:id" element={<ViewDatasetPage />} />
                <Route path="gp/users" element={<UsersPage />} />
                <Route path="gp/users/view/:id" element={<ViewUserIdPage />} />
                <Route path="gp/users/edit/:id" element={<EditUserPage />} />
                <Route path="gp/users/add" element={<AddUserPage />} />

                {/* App Users Pages */}
                <Route path="gp/app/users" element={<AppUserPage />} />
                <Route path="gp/app/users/add" element={<AddAppUserPage />} />
                <Route path="gp/app/users/edit/:id" element={<EditAppUserPage />} />
                <Route path="gp/app/users/view/:id" element={<ViewAppUserIdPage />} />

                {/* App Announcements Pages */}
                <Route path="gp/app/announcements" element={<AppAnnouncementPage />} />
                <Route path="gp/app/announcements/add" element={<AddAppAnnouncementPage />} />
                <Route path="gp/app/announcements/edit/:id" element={<EditAppAnnouncementPage />} />
                <Route path="gp/app/announcements/view/:id" element={<ViewAppAnnouncementIdPage />} />

                {/* App Pre Call Plans Pages */}
                <Route path="gp/app/precallplans" element={<AppPreCallPlanPage />} />
                <Route path="gp/app/precallplans/calendar" element={<AppPreCallPlanCalendarPage />} />
                <Route path="gp/app/precallplans/view/:id" element={<ViewAppPreCallPlanIdPage />} />

                {/* App Post Call Plans Pages */}
                <Route path="gp/app/postcallplans" element={<AppPostCallPlanPage />} />
                <Route path="gp/app/postcallplans/calendar" element={<AppPostCallPlanCalendarPage />} />
                <Route path="gp/app/postcallplans/view/:id" element={<ViewAppPostCallPlanIdPage />} />

                {/* App Check Ins Pages */}
                <Route path="gp/app/track/checkins" element={<AppTrackCheckInPage />} />
                <Route path="gp/app/track/checkins/view/:id" element={<ViewAppTrackCheckInIdPage />} />

                {/* App Locations Pages */}
                <Route path="gp/app/track/locations" element={<AppTrackLocationPage />} />
                <Route path="gp/app/track/locations/add" element={<AddAppTrackLocationPage />} />
                <Route path="gp/app/track/locations/edit/:id" element={<EditAppTrackLocationPage />} />
                <Route path="gp/app/track/locations/view/:id" element={<ViewAppTrackLocationIdPage />} />

                {/* App User Current Location Pages */}
                <Route path="gp/app/track/usercurrentlocation" element={<AppUserCurrentLocationPage />} />
                <Route path="/gp/app/track/usercurrentlocation/view/:id" element={<ViewAppUserCurrentLocationIdPage />} />
                <Route path="gp/app/updates" element={<AppUpdatesPage />} />
                <Route path="gp/app/updates/add" element={<AddAppUpdatePage />} />
                <Route path="gp/app/updates/edit/:id" element={<EditAppUpdatePage />} />
                <Route path="gp/app/updates/view/:id" element={<ViewAppUpdateIdPage />} />

              </Route>

              <Route element={<PageAccess requiredRole='1' requiredRole2='2' />}>
                {/* Brand Pages */}
                <Route path="gp/inventories/brands" element={<SetupBrandPage />} />
                <Route path="gp/inventories/brands/add" element={<SetupAddBrandPage />} />
                <Route path="gp/inventories/brands/edit/:id" element={<SetupEditBrandPage />} />
                <Route path="gp/inventories/brands/view/:id" element={<SetupViewBrandIdPage />} />

                {/* Categories Pages */}
                <Route path="gp/inventories/categories" element={<WarehouseProductCategoryPage />} />
                <Route path="gp/inventories/categories/add" element={<AddWarehouseProductCategoryPage />} />
                <Route path="gp/inventories/categories/edit/:id" element={<EditWarehouseProductCategoryPage />} />
                <Route path="gp/inventories/categories/view/:id" element={<ViewWarehouseProductCategoryIdPage />} />

                {/* Departments Pages */}
                <Route path="gp/inventories/departments" element={<WarehouseProductDepartmentPage />} />
                <Route path="gp/inventories/departments/add" element={<AddWarehouseProductDepartmentPage />} />
                <Route path="gp/inventories/departments/edit/:id" element={<EditWarehouseProductDepartmentPage />} />
                <Route path="gp/inventories/departments/view/:id" element={<ViewWarehouseProductDepartmentIdPage />} />

                {/* Groups Pages */}
                <Route path="gp/inventories/groups" element={<WarehouseProductGroupPage />} />
                <Route path="gp/inventories/groups/add" element={<AddWarehouseProductGroupPage />} />
                <Route path="gp/inventories/groups/edit/:id" element={<EditWarehouseProductGroupPage />} />
                <Route path="gp/inventories/groups/view/:id" element={<ViewWarehouseProductGroupIdPage />} />

                {/* Product Pages */}
                <Route path="gp/inventories/products" element={<WarehouseProductPage />} />
                <Route path="gp/inventories/products/add" element={<AddWarehouseProductPage />} />
                <Route path="gp/inventories/products/add/items/:id" element={<AddWarehouseProductItemPageId />} />
                <Route path="gp/inventories/products/prices/add/:id" element={<AddWarehouseProductPiceListPage />} />
                <Route path="gp/inventories/products/edit/:id" element={<EditWarehouseProductPage />} />
                <Route path="gp/inventories/products/view/:id" element={<ViewWarehouseProductIdPage />} />

                {/* Product Items Pages */}
                {/* <Route path="gp/inventories/products/items/add" element={<AddWarehouseProductItemPage />} /> */}

                {/* Stock in Pages */}
                <Route path="gp/stocks/stockin" element={<StockInPage />} />
                <Route path="gp/stocks/stockin/add" element={<AddStockInPage />} />
                <Route path="gp/stocks/stockin/add/items/:id" element={<AddStockInItemPageId />} />
                <Route path="gp/stocks/stockin/edit/:id" element={<EditStockInPage />} />
                <Route path="gp/stocks/stockin/view/:id" element={<ViewStockInIdPage />} />

                {/* Stock in items Pages */}
                {/* <Route path="gp/stocks/stockin/items/add" element={<AddStockInItemPage />} /> */}

                {/* Stock out Pages */}
                <Route path="gp/stocks/stockout" element={<StockOutPage />} />
                <Route path="gp/stocks/stockout/add" element={<AddStockOutPage />} />
                <Route path="gp/stocks/stockout/add/items/:id" element={<AddStockOutItemPageId />} />
                <Route path="gp/stocks/stockout/view/:id" element={<ViewStockOutIdPage />} />
                <Route path="gp/stocks/stockout/edit/:id" element={<EditStockOutPage />} />

                {/* Stock out items Pages */}
                {/* <Route path="gp/stocks/stockout/items/add" element={<AddStockOutItemPage />} /> */}

                {/* Stock adjust Pages */}
                <Route path="gp/stocks/stockadjust" element={<StockAdjustPage />} />
                <Route path="gp/stocks/stockadjust/add" element={<AddStockAdjustPage />} />
                <Route path="gp/stocks/stockadjust/add/items/:id" element={<AddStockAdjustItemPageId />} />
                <Route path="gp/stocks/stockadjust/view/:id" element={<ViewStockAdjustIdPage />} />
                <Route path="gp/stocks/stockadjust/edit/:id" element={<EditStockAdjustPage />} />

                {/* Stock adjust items Pages */}
                {/* <Route path="gp/stocks/stockadjust/items/add" element={<AddStockAdjustItemPage />} /> */}

                {/* Pickup Pages */}
                <Route path="gp/tracking/pickups" element={<PickupStockOutPage />} />
                <Route path="gp/tracking/pickups/view/:id" element={<ViewTrackingPickupIdPage />} />

                {/* Tracking Standalone Pages */}
                <Route path="gp/tracking/standalone" element={<TrackingStandalonePage />} />
                <Route path="gp/tracking/standalone/add" element={<AddTrackingStandalonePage />} />
                <Route path="gp/tracking/standalone/edit/:id" element={<EditTrackingStandalonePage />} />
                <Route path="gp/tracking/standalone/view/:id" element={<ViewTrackingStandalonePage />} />

                {/* Completed Pages */}
                <Route path="gp/tracking/completed" element={<CompletedStockOutPage />} />

                {/* Supplier Pages */}
                <Route path="gp/setup/suppliers" element={<SetupSuppliersPage />} />
                <Route path="gp/setup/suppliers/add" element={<SetupAddSupplierPage />} />
                <Route path="gp/setup/suppliers/edit/:id" element={<SetupEditSupplierPage />} />
                <Route path="gp/setup/suppliers/view/:id" element={<SetupViewSupplierIdPage />} />

                {/* Logistic Pages */}
                <Route path="gp/setup/logistics" element={<SetupLogisticsPage />} />
                <Route path="gp/setup/logistics/add" element={<SetupAddLogisticPage />} />
                <Route path="gp/setup/logistics/edit/:id" element={<SetupEditLogisticPage />} />
                <Route path="gp/setup/logistics/view/:id" element={<SetupViewLogisticIdPage />} />

                {/* Customer Pages */}
                <Route path="gp/setup/customers" element={<SetupCustomersPage />} />
                <Route path="gp/setup/customers/add" element={<SetupAddCustomerPage />} />
                <Route path="gp/setup/customers/edit/:id" element={<SetupEditCustomerPage />} />
                <Route path="gp/setup/customers/view/:id" element={<SetupViewCustomerIdPage />} />

                {/* Warehouses Pages */}
                <Route path="gp/warehouses" element={<SetupWarehousesPage />} />
                <Route path="gp/warehouses/add" element={<SetupAddWarehousePage />} />
                <Route path="gp/warehouses/edit/:id" element={<SetupEditWarehousePage />} />
                <Route path="gp/warehouses/view/:id" element={<SetupViewWarehouseIdPage />} />

                {/* Sales Order Pages */}
                <Route path="gp/salesorders" element={<AppSalesOrdersPage />} />
                <Route path="gp/salesorders/view/:id" element={<ViewAppSalesOrderIdPage />} />

                {/* Stock Balance Transfer */}
                <Route path="gp/stockbalancetransfer" element={<StockBalanceTransferPage />} />
                <Route path="gp/stockbalancetransfer/:id" element={<AddStockBalanceTransferIdPage />} />
              </Route>

              {/* Report Pages */}
              <Route path="gp/reports/stockbalance" element={<ReportStockBalancePage />} />
              <Route path="gp/reports/stockbalance/view/:id" element={<ReportStockBalanceIdPage />} />
              <Route path="gp/reports/stockmovement" element={<ReportStockMovementPage />} />
              <Route path="gp/reports/stockmovement/view/:id" element={<ReportStockMovementIdPage />} />
              <Route path="gp/reports/stockbybatch" element={<ReportStockByBatchPage />} />
              <Route path="gp/reports/stockbybatch/view/:id" element={<ReportStockByBatchIdPage />} />

              {/* My Account Pages */}
              <Route path="gp/myaccount/edit" element={<EditMyAccountPage />} />
              <Route path="gp/myaccount/view" element={<ViewMyAccountPage />} />
            </Route>

            <Route path="/developers/kingdomcodeworks/adduser" element={<DeveloperAddUserPage />} />
          </Route>
          <Route path="*" element={<NotFoundPage />} />

        </Routes>

      </UserProvider>
    </Router>
    </ThemeProvider>
  );
};

export default App;
